import PropTypes from 'prop-types'
import Button from './Button'
import reactWhite from './images/logofx.png';
import reactPurple from './images/react.png';
import reactBlue from './images/logo.png';
import spaceMan from './images/astronautorangesaucersmall.png';
import spaceMan2 from './images/astronautbandwdmed.png';
import spaceship from './images/spaceshipsmall.png';
// import volumeDial from './images/volumejogdial.png';
// import Howling from './Howling';
// import Howling from  './Howling';
// import AnimateControls from './AnimateControls' ;


// Make sure to include your addAnimationControl and showAddAnimationControl here
export const Header = ({title, onAdd, showAdd, onAnimate}) => {
  return (
    <div>


 <header className="header">	

      <h1 className='header' style={ headingStyle } > { title }</h1>
      <Button  color={showAdd ? 'rgb(138,43,226) ' :  'rgb(66, 140, 5)'} text={showAdd ? 'Close Task Menu' : 'Add Task Menu'}   onClick={onAdd} idName="add-task" className='add-task'   /> 

 

      {/* onDoubleClick={Howling.play()} */}
     {/* <AnimateControls  className="animateControls" /> */}


      {/* <Button  color={showAdd ? 'rgb(0,191,255) ' :  'rgb(163, 93, 2)'} text={showAdd ? 'Close Animation Controls' : 'R E A C T: Gravity and Drag 🚀 Animation Controls'} onClick={onAnimate} idName="add-task" className='add-task animation-controls'  />  */}

    {/* This needs work */}
      {/* <Button  color={showAdd ? 'rgb(0,191,255) ' :  'rgb(163, 93, 2)'} text={showAdd ? 'Close Animation Controls' : 'R E A C T: Gravity and Drag 🚀 Animation Controls'} className='animation-controls' onClick={<AnimateControls />} /> */}
     
      <img src={reactWhite} className="react-white" id="react-white" alt="React White Logo" />
      <img src={reactPurple} className="react-purple" id="react-purple"  alt="React Purple Logo" /> 
      <img src={reactBlue} className="react-blue" id="react-blue"  alt="React Blue Logo" /> 
      <img src={spaceMan} className="spaceMan" id="space-man" alt="Space Man" /> 
      <img src={spaceMan2} className="spaceMan2" id="space-man2" alt="Space Man Floating" /> 
      <img src={spaceship} className="FlyingSaucer" id="flying-saucer" alt="Space Man Hovering" /> 
      
      {/* <img src={volumeDial} className="volumeDial volumeDialRotate" id="volume-jog-dial" alt="Music Jog Dial" />  */}
   

      </header>
      </div>
  )
}

Header.defaultProps = {
    title: 'Task Tracker' , 
}
Header.propTypes = {
    title:  PropTypes.string.isRequired,
}

const headingStyle = {
    color:  'whitesmoke' ,
     backgroundColor: '#61919e ',

}
export default Header
